"use strict";

(function(){
var self = Fotobook.containers.calendar.style = {},
    highlightClassMap = {};

highlightClassMap[Fotobook.containers.calendar.HIGHLIGHT_WEEK_EVEN] = Fotobook.containers.calendar.CLASS_WEEK_EVEN;
highlightClassMap[Fotobook.containers.calendar.HIGHLIGHT_WEEK_ODD] = Fotobook.containers.calendar.CLASS_WEEK_ODD;
highlightClassMap[Fotobook.containers.calendar.HIGHLIGHT_DAY_EVEN] = Fotobook.containers.calendar.CLASS_DAY_EVEN;
highlightClassMap[Fotobook.containers.calendar.HIGHLIGHT_DAY_ODD] = Fotobook.containers.calendar.CLASS_DAY_ODD;


$.extend(self, {
    highlightClassMap: highlightClassMap,

    // todo реоиганизовать (разделить)
    css : {
        // добавляем, чтобы в процессе добавления полей у нас не возникали неинициализированные значения
        // Со временем можно удалить
        defaultValues: {
            "border_color" : "black",
            "border_width" : 0,
            "month_color" : "black",
        },
        templates : {
            weekendColor                   : '#{uniqueId} .day-weekend{color:{holidays_color};}',
            regularColor                   : '#{uniqueId} .day-regular{color:{numbers_color};}',
            backgroundColor                : [
                                                '#{uniqueId} .background-grid .day-number{background-color:{background_color};}',
                                                '#{uniqueId} .background-grid .day-number.{highlightItemSelector}{background-color:{background_color_highlighted};}'
                                            ].join("\n"),
            externalColor                  : '#{uniqueId} .calendar-cell.day-external-month{color:{numbers_color_external};}',
            holidayTitleColor              : '#{uniqueId} .calendar-cell-title{color:{holidays_color};}',

            numbersFontFamily              : '#{uniqueId} .numbers-font-styles{font-family:{numbersFontFamily};}',
            numbersBold                    : '#{uniqueId} .numbers-font-styles{font-weight:{numbersFontWeight};}',
            numbersItalic                  : '#{uniqueId} .numbers-font-styles{font-style:{numbersFontStyle};}',
            numbersFontSize                : '#{uniqueId} .numbers-font-styles{font-size:{numbersFontSize};}',

            numbersTitleFontFamily         : '#{uniqueId} .numbers-title-font-styles{font-family:{numbersTitleFontFamily};}',
            numbersTitleBold               : '#{uniqueId} .numbers-title-font-styles{font-weight:{numbersTitleFontWeight};}',
            numbersTitleItalic             : '#{uniqueId} .numbers-title-font-styles{font-style:{numbersTitleFontStyle};}',
            numbersTitleFontSize           : '#{uniqueId} .numbers-title-font-styles{font-size:{numbersTitleFontSize};}',

            monthColor                     : '#{uniqueId} .calendar-header-cell{color:{month_color};}',
            monthFontFamily                : '#{uniqueId} .calendar-header-cell{font-family:{monthFontFamily};}',
            monthBold                      : '#{uniqueId} .calendar-header-cell{font-weight:{monthFontWeight};}',
            monthItalic                    : '#{uniqueId} .calendar-header-cell{font-style:{monthFontStyle};}',
            monthFontSize                  : '#{uniqueId} .calendar-header-cell{font-size:{monthFontSize};}',

            borderWidth                    : '#{uniqueId} .calendar-cell{border-width:{borderWidthEm};}',
            borderColor                    : '#{uniqueId} .calendar-cell{border-color:{borderColorNoOpacity};}',
            borders                        : '#{uniqueId} .calendar-cell{border-style:{borderHorizontalStyle} {borderVerticalStyle};}',

            dayNameBold                    : '#{uniqueId} .day-name-font-styles{font-weight:{dayNameFontWeight};}',
            dayNameColorText               : '#{uniqueId} .day-name-font-styles{color:{day_name_color_text};}',
            dayNameColorBackground         : [
                                                '#{uniqueId} .background-grid .day-name-label{background-color:{day_name_color_background};}',
                                                '#{uniqueId} .background-grid .day-name-label.{highlightItemSelector}{background-color:{day_name_color_background_highlighted};}',
                                             ].join("\n"),
            dayNameFontFamily              : '#{uniqueId} .day-name-font-styles{font-family:{dayNameFontFamily};}',
            dayNameItalic                  : '#{uniqueId} .day-name-font-styles{font-style:{dayNameFontStyle};}',
            dayNameFontSize                : '#{uniqueId} .day-name-font-styles{font-size:{dayNameFontSize};}',

            weekNumbersBold                : '#{uniqueId} .week-number-font-styles{font-weight:{weekNumbersFontWeight};}',
            weekNumbersItalic              : '#{uniqueId} .week-number-font-styles{font-style:{weekNumbersFontStyle};}',
            weekNumbersFontSize            : '#{uniqueId} .week-number-font-styles{font-size:{weekNumbersFontSize};}',
            weekNumbersFontFamily          : '#{uniqueId} .week-number-font-styles{font-family:{weekNumbersFontFamily};}',
            weekNumbersColor               : '#{uniqueId} .week-number-font-styles{color:{week_numbers_color};}',
            weekNumbersBackgroundColor     : [
                                                '#{uniqueId} .background-grid .week-number{background-color:{week_numbers_background_color};}',
                                                '#{uniqueId} .background-grid .week-number.{highlightItemSelector}{background-color:{week_numbers_background_color_highlighted};}',
                                             ].join("\n"),
            numberSecondaryColorBackground : [
                                                '#{uniqueId} .background-grid .day-secondary-weekend.day-inside-month{background-color:{holidays_secondary_background_color};}',
                                                '#{uniqueId} .background-grid .day-secondary-weekend.day-inside-month.{highlightItemSelector}{background-color:{holidays_secondary_background_color_highlighted};}',
                                            ].join("\n"),
            numberSecondaryColor           : '#{uniqueId} .day-secondary-weekend.day-inside-month{color:{holidays_secondary_color};}',
            holidayBackgroundColor         : [
                                                '#{uniqueId} .background-grid .day-weekend.day-inside-month{background-color:{holidays_background_color};}',
                                                '#{uniqueId} .background-grid .day-weekend.day-inside-month.{highlightItemSelector}{background-color:{holidays_background_color_highlighted};}',
                                            ].join("\n"),
        },
        modify: {

            borderColor: function(params){
                var color = new WebColor(params.border_color);
                params.borderColorNoOpacity = color.get_rgb();
            },
            borderWidth: function(params){
                params.borderWidthEm = Fotobook.book.getSizeInEm(params.border_width / 10 * params.dX);
            },
            borders: function(params){
                var vertical = (params.borders & Fotobook.containers.calendar.BORDER_VERTICAL) === Fotobook.containers.calendar.BORDER_VERTICAL,
                    horizontal = (params.borders & Fotobook.containers.calendar.BORDER_HORIZONTAL) === Fotobook.containers.calendar.BORDER_HORIZONTAL;

                params.borderVerticalStyle = vertical ? "solid" : "none";
                params.borderHorizontalStyle = horizontal ? "solid" : "none";
            },
            numbersFontFamily: function(params) {
                Fotobook.store.commit('Fonts/loadFontById', params.numbers_font_id);
                params.numbersFontFamily = Fotobook.store.getters['Fonts/getFontById'](params.numbers_font_id)?.family ?? '';
            },
            numbersBold: function(params){
                params.numbersFontWeight = params.numbers_bold ? "bold" : "normal";
            },
            numbersItalic: function(params){
                params.numbersFontStyle = params.numbers_italic ? "italic" : "normal";
            },
            numbersTitleFontFamily: function(params){
                Fotobook.store.commit('Fonts/loadFontById', params.numbers_title_font_id);
                params.numbersTitleFontFamily = Fotobook.store.getters['Fonts/getFontById'](params.numbers_title_font_id)?.family ?? '';
            },
            numbersTitleBold: function(params){
                params.numbersTitleFontWeight = params.numbers_title_bold ? "bold" : "normal";
            },
            numbersTitleItalic: function(params){
                params.numbersTitleFontStyle = params.numbers_title_italic ? "italic" : "normal";
            },
            monthFontFamily: function(params){
                Fotobook.store.commit('Fonts/loadFontById', params.month_font_id);
                params.monthFontFamily = Fotobook.store.getters['Fonts/getFontById'](params.month_font_id)?.family ?? '';
            },
            monthBold: function(params){
                params.monthFontWeight = params.month_bold ? "bold" : "normal";
            },
            monthItalic: function(params){
                params.monthFontStyle = params.month_italic ? "italic" : "normal";
            },
            numbersTitleFontSize: function(params) {
                params.numbersTitleFontSize = Fotobook.book.getSizeInEm(params.numbers_title_font_size * params.dX);
            },
            numbersFontSize: function(params) {
                params.numbersFontSize = Fotobook.book.getSizeInEm(params.numbers_font_size * params.dX);
            },
            monthFontSize: function(params) {
                params.monthFontSize = Fotobook.book.getSizeInEm(params.month_font_size * params.dX);
            },
            dayNameFontFamily: function(params){
                Fotobook.store.commit('Fonts/loadFontById', params.day_name_font_id);
                params.dayNameFontFamily = Fotobook.store.getters['Fonts/getFontById'](params.day_name_font_id)?.family ?? '';
            },
            dayNameBold: function(params){
                params.dayNameFontWeight = params.day_name_font_bold ? "bold" : "normal";
            },
            dayNameItalic: function(params){
                params.dayNameFontStyle = params.day_name_font_italic ? "italic" : "normal";
            },
            dayNameFontSize: function(params){
                params.dayNameFontSize = Fotobook.book.getSizeInEm(params.day_name_font_size * params.dX);
            },

            weekNumbersBold: function(params){
                params.weekNumbersFontWeight = params.week_numbers_bold ? "bold" : "normal";
            },
            weekNumbersItalic: function(params){
                params.weekNumbersFontStyle = params.week_numbers_italic ? "italic" : "normal";
            },
            weekNumbersFontSize: function(params){
                params.weekNumbersFontSize = Fotobook.book.getSizeInEm(params.week_numbers_font_size * params.dX);
            },
            weekNumbersFontFamily: function(params){
                Fotobook.store.commit('Fonts/loadFontById', params.week_numbers_font_id);
                params.weekNumbersFontFamily = Fotobook.store.getters['Fonts/getFontById'](params.week_numbers_font_id)?.family ?? '';
            },
            backgroundColor: function(params){
                self.setHighlightSeletor(params);
                self.setHighlightColor(params, "background_color");
            },
            holidayBackgroundColor: function(params){
                self.setHighlightSeletor(params);
                self.setHighlightColor(params, "holidays_background_color");
            },
            numberSecondaryColorBackground: function(params){
                self.setHighlightSeletor(params);
                self.setHighlightColor(params, "holidays_secondary_background_color");
            },
            dayNameColorBackground: function(params){
                self.setHighlightSeletor(params);
                self.setHighlightColor(params, "day_name_color_background");
            },
            weekNumbersBackgroundColor: function(params){
                self.setHighlightSeletor(params);
                self.setHighlightColor(params, "week_numbers_background_color");
            },
        },

        get : function(type, uniqueId, dX, calendar){
            var params = $.extend({
                    "uniqueId" : uniqueId,
                    "dX" : dX,
                }, this.defaultValues, calendar);

            if (this.modify.hasOwnProperty(type)){
                this.modify[type](params);
            }
            return this.templates[type].supplant(params);
        },

        getAll: function(uniqueId, dX, calendar){
            var styles = [];

            for (var i in this.templates){
                if (this.templates.hasOwnProperty(i)){
                    styles.push(this.get(i, uniqueId, dX, calendar));
                }
            }
            return styles;
        },
    },

    renderAll: function(uniqueId, dX, calendar){
        return [
            '<style class="calendar-style">',
                self.css.getAll(uniqueId, dX, calendar).join("\n"),
            '</style>',
        ].join("\n");
    },

    /** рендеринг временного стиля */
    _renderOverride: function(id, types, dX, params, styleClass){
        styleClass = styleClass || Fotobook.book.getUniqueId();
        if (!(types instanceof Array)){
            types = [types];
        }
        return [
            '<style class="override-style ' + styleClass + '">',
                types.map(function(type){
                    return this.css.get(type, id, dX, params);
                }, this).join("\n"),
            '</style>',
        ].join("\n");
    },

    addOverride: function($element, types, params, styleClass){
        styleClass = styleClass || Fotobook.book.getUniqueId();

        var id = $element.attr("id"),
            dX = $element.getDx(),
            styleContent = this._renderOverride(id, types, dX, params, styleClass);

        this.removeOverride(styleClass);
        $element.append(styleContent);
        return styleClass;
    },

    removeOverride: function(styleClass){
        $("."+styleClass).remove();
    },

    /** устанавливаем селектор для выделения чётных/нечётных элемент */
    setHighlightSeletor: function(params){
        if (!params.highlightItemSelector){
            params.highlightItemSelector = self.highlightClassMap[params.highlight_item] || "fake-selector";
        }
    },

    /** устанавливаем модифицированный цвет для подсветки чётных/нечётных элементов */
    setHighlightColor: function(params, paramName) {
        if (params.highlight_item) {
            var color = new WebColor(params[paramName]);
            params[paramName + "_highlighted"] = color.changeBrightness(params.highlight_value/100).get_rgba();
        }
    },
});

})();
